import Checkbox from 'components/Checkbox';
import Fieldset from 'components/Fieldset';
import { useTranslation } from 'next-i18next';

const CreateEmailAlertForm = ({
  saving,
  disabled,
  onInputChange,
  inputs,
  query,
  city,
}) => {
  const { t } = useTranslation();

  return (
    <Fieldset title={t('emailAlert.label')} disabled={disabled || saving}>
      <Checkbox
        label={t('emailAlert.create', {
          query,
          city,
        })}
        name="createEmailAlert"
        id="createEmailAlert"
        test="createEmailAlert"
        onChange={onInputChange}
        checked={inputs.createEmailAlert}
      />
    </Fieldset>
  );
};

export default CreateEmailAlertForm;
